import type { CountriesContextType } from './types'
import { createContext } from 'react'

export const CountriesContext = createContext<CountriesContextType | undefined>(undefined)
